module.exports = __webpack_public_path__ + "static/img/8.6185694.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/zh/8.png
// module id = b0DC
// module chunks = 0